import { fetchApi } from "../../app/lib/api"
import { Types } from './types'
import { checkErrorCode } from '../auth/actions'
import { LIMIT_PAGE } from '../../lib/common'

export const getConfigNotify = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/notify/config-notify-price?key=${payload}`, "get", payload)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}
export const sendNotifyTopic = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/notify/sendTopic`, "post", payload)
        dispatch(actionLoading(false))
        return response
    } catch (error) {
        alert(error || error?.message)
    }
}
export const sendNotifyOnesignal = (payload) => async (dispatch) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/notify/sendOnesignal`, "post", payload)
        dispatch(actionLoading(false))
        return response?.message
    } catch (error) {
        alert(error || error?.message)
    }
}
export const updateConfigNotify = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/notify/config-notify-price`, "post", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}
export const actionGetListConfig = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/config/list`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListConfig(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}
export const actionDeleteConfig = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload

    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/config/del`, "post", dataPush)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        //thêm
        if (!payload.id) {
            await dispatch(actionGetListConfig(filterModal))
        }
        //sửa
        else {
            const state = getState()
            const dataPost = state?.postReducer?.dataPost
            let newData = { ...dataPost }

            const index = newData.rows.findIndex(it => it.id === payload.id)
            newData.rows[index] = response.data
            await dispatch(actionSaveListConfig(filterModal))
        }
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionUpdateConfig = (payload) => async (dispatch, getState) => {
    const { filterModal, dataPush } = payload
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/config/update`, "post", dataPush)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        await dispatch(actionGetListConfig(filterModal))
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        alert(error || error?.message)
    }
}
export const actionGetSettingMenu = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/app/menubar/list`, "get", payload)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        dispatch(actionLoading(false))
        return response
    } catch (error) {
        alert(error || error?.message)
    }
}
export const actionPostSettingMenu = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/menubar/update`, "post", payload)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        dispatch(actionLoading(false))
        return response
    } catch (error) {
        alert(error || error?.message)
    }
}
export const actionUpdateConfigCMS = (payload) => async (dispatch, getState) => {
    const { filterModal, dataPush } = payload
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/config/update-cms`, "post", payload)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        // await dispatch(actionGetListConfig(filterModal))
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionSaveListConfig = (payload) => ({
    type: Types.SAVE_LIST_CONFIG,
    payload,
})



export const actionLoading = (payload) => ({
    type: Types.SAVE_LOADINGS,
    payload,
})

export const actionSaveOpenHideSiderBar = (payload) => ({
    type: Types.SAVE_OPEN_HIDE_SIDERBAR,
    payload,
})

export const actionGetMarketingList = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload;
        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/marketing/list`, "get", payload)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListConfig(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionUpdateMarketing = (payload) => async (dispatch, getState) => {
    const { filterModal, dataPush } = payload
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/marketing/save-setting`, "post", payload)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionGetHistoryUpdatePrice = (payload) => async (
    dispatch,
    getState
) => {
    try {
        dispatch(actionLoading(true));
        const { page } = payload;
        payload.limit = LIMIT_PAGE;

        let response = await fetchApi(
            `/admin/crawl/history-update-price`,
            "get",
            payload
        );

        if (response.code !== 200) {
            dispatch(actionLoading(false));
            return checkErrorCode(response?.code, response?.message);
        }
        response.data = {
          ...response.data,
          paging: {
            page: page || 1,
            total: response?.data?.total || 0,
            count: Math.ceil(response?.data?.total / LIMIT_PAGE),
            limit: LIMIT_PAGE,
          },
        };
        await dispatch(actionSaveGoldOfficial(response.data));
        dispatch(actionLoading(false));
        return response.data;
    } catch (error) {
        alert(error || error?.message);
    }
};

export const actionSaveGoldOfficial = (payload) => ({
    type: Types.SAVE_HISTORY_PRICE,
    payload,
});
